import { Avatar, Group, Text, UnstyledButton } from "@mantine/core"
import { FormatCurrency } from "components/Currency"
import ImagePlaceholder from "icons/ImagePlaceholder"
import type React from "react"
import type { Offer } from "../../offersList/offersListTypes"

interface MenuOfferItemProps {
  offer: Offer
  checked: boolean
  onClick: () => void
}

const MenuOfferItem: React.FC<MenuOfferItemProps> = ({
  offer,
  checked,
  onClick,
}) => {
  const { AccommodationName, OfferTitle, Nights, LeadInPrice, ImageURL } = offer

  return (
    <UnstyledButton
      onClick={onClick}
      className="w-full p-2 transition-colors"
      style={{
        backgroundColor: checked ? "var(--mantine-primary-color-light)" : undefined,
      }}
      onMouseEnter={(e) => {
        if (!checked) e.currentTarget.style.backgroundColor = "var(--mantine-color-gray-0)"
      }}
      onMouseLeave={(e) => {
        if (!checked) e.currentTarget.style.backgroundColor = ""
      }}
    >
      <Group wrap="nowrap" align="flex-start">
        <Avatar
          src={ImageURL}
          size={96}
          radius="sm"
          alt={`${OfferTitle} - ${AccommodationName}`}
        >
          <ImagePlaceholder />
        </Avatar>

        <div className="flex-1 min-w-0">
          <Group justify="space-between" wrap="nowrap">
            <Text size="sm" fw={500} lineClamp={1}>
              {OfferTitle || "Título não disponível"}
            </Text>
            <Text size="sm" fw={500} style={{ whiteSpace: "nowrap" }}>
              <FormatCurrency value={LeadInPrice} />
            </Text>
          </Group>

          <Text size="xs" c="dimmed" mt={4}>
            {AccommodationName}
          </Text>

          {Nights ? (
            <Text size="xs" c="dimmed" mt={4}>
              {Nights} Noites
            </Text>
          ) : (
            <Text size="xs" c="gray.5" mt={4}>
              Duração não especificada
            </Text>
          )}
        </div>
      </Group>
    </UnstyledButton>
  )
}

export default MenuOfferItem
